import React from "react"
import PropTypes from "prop-types"

import StandardModal from '../../app_components/StandardModal'
import StandardButton from '../../app_components/StandardButton'
import ChatContainer from '../../chat_components/ChatContainer';
import NewLexForm from './NewLexForm'

class ChatMeetingButtons extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      chatOpen: false,
      scheduleLexOpen: false
    }
    this.toggleScheduleLex = this.toggleScheduleLex.bind(this)
    this.toggleChat = this.toggleChat.bind(this)
    this.renderChat = this.renderChat.bind(this)
    this.renderScheduleLex = this.renderScheduleLex.bind(this)
  }

  toggleScheduleLex() {
    this.setState({
      scheduleLexOpen: !this.state.scheduleLexOpen
    })
  }

  toggleChat() {
    this.setState({
      chatOpen: !this.state.chatOpen
    })
  }

  renderChat() {
    return(
      <div style={{
        top: 54,
        left: 0,
        position: 'fixed',
        width: '100%',
        height: '100%',
        zIndex: 111,
        backgroundColor: 'rgba(255,255,255,.5)'
      }}>
        <ChatContainer
          convoId={this.props.convoId}
          missingImg={this.props.missingImg}
          closeChat={this.toggleChat}
        />
      </div>
    )
  }

  renderScheduleLex() {
    return(
      <NewLexForm
        otherUserId={this.props.otherUserId}
        onClose={this.toggleScheduleLex}
      />)
  }

  render() {
    return(
      <div>
        {this.state.chatOpen && this.renderChat()}
        {this.state.scheduleLexOpen && this.renderScheduleLex()}
        <div style={{display: 'flex', justifyContent: 'space-around', width: 350, margin: 'auto'}}>
          <div>
            <StandardButton
              primary={false}
              size={'large'}
              text="Schedule Lex"
              onClick={() => this.toggleScheduleLex()}
             />
         </div>
         <div>
           <StandardButton
             primary={true}
             size={'large'}
             text="Chat"
             onClick={() => this.toggleChat()}
            />
         </div>
        </div>
      </div>
    )
  }

}

export default ChatMeetingButtons;
